import React from 'react';
import './Legal.css';

const PrivacyPolicy = () => {
  return (
    <div className="legal-container">
      <div className="legal-content">
        <h1>Privacy Policy</h1>
        <p className="legal-fecha">Last updated: October 12, 2026</p>
        <p><a href="/aviso-privacidad">Leer este aviso en español</a></p>

        <section>
          <h2>1. Data controller</h2>
          <p>
            <strong>Xaltech Manufacturing Services SA de CV</strong> ("the Company" or "Xaltech Fotos"),
            contact email: <strong>xaltech1990@outlook.com</strong>, is the controller responsible for the
            processing of your personal data. Xaltech Fotos operates a digital platform that provides
            services to photographers and athletes both in Mexico and in other countries, so this notice
            is written to follow an international data protection standard.
          </p>
          <p>
            As our primary legal framework we apply Mexico's Federal Law on Protection of Personal Data
            Held by Private Parties (LFPDPPP) and its Regulations. In addition, where applicable law
            requires it, we recognize rights equivalent to those under the European Union's General Data
            Protection Regulation (GDPR) and the California Consumer Privacy Act (CCPA/CPRA); see Section 6.
          </p>
        </section>

        <section>
          <h2>2. Personal data we collect</h2>
          <p>For <strong>photographers</strong> registered on the platform:</p>
          <ul>
            <li>Full name</li>
            <li>Email address</li>
            <li>Phone number</li>
          </ul>
          <p>For <strong>athletes / buyers</strong> using the service via WhatsApp:</p>
          <ul>
            <li>WhatsApp phone number</li>
            <li>Bib/race number</li>
            <li>Payment information processed by Stripe (we do not store card data)</li>
          </ul>
        </section>

        <section>
          <h2>3. Purposes of processing</h2>
          <p>Your data is used to:</p>
          <ul>
            <li>Identify and deliver sports event photographs to the corresponding athlete</li>
            <li>Process payments through Stripe</li>
            <li>Manage the business relationship with registered photographers</li>
            <li>Send notifications related to your photos via WhatsApp</li>
            <li>Comply with tax and legal obligations</li>
          </ul>
        </section>

        <section>
          <h2>4. Data transfers</h2>
          <p>
            Your personal data will not be transferred to third parties without your consent, except as
            permitted under applicable law, including payment processors (Stripe) and technology
            infrastructure providers (Microsoft Azure) under confidentiality agreements.
          </p>
          <p>
            <strong>International transfer:</strong> our technology infrastructure (Microsoft Azure) hosts
            data in data centers located in the United States. By using our services, you consent to this
            international transfer, carried out under the data protection agreements Microsoft Azure offers
            its business customers.
          </p>
          <p>
            If you participate in an event held outside Mexico, your data may also be transferred to and
            processed in the country where that event is organized, in all cases applying reasonable
            security measures to protect your information.
          </p>
        </section>

        <section>
          <h2>5. Biometric data (facial recognition)</h2>
          <p>
            For events offering selfie-based photo search, we process a <strong>sensitive personal
            data</strong> category: a mathematical pattern (embedding) derived from your face, used
            exclusively to compare your selfie against the faces detected in the event's photographs.
          </p>
          <ul>
            <li>We do not store the selfie image itself; only the mathematical pattern generated from it.</li>
            <li>This data is used exclusively to search for your photos at the corresponding event, never for any other purpose.</li>
            <li>It is automatically deleted if the event is removed from the platform, or earlier upon your request.</li>
            <li>We collect this data only with express consent, requested separately before processing any selfie.</li>
          </ul>
          <p>
            If the selfie corresponds to a minor, the person sending it declares to be their parent or legal
            guardian and to be granting consent on the minor's behalf.
          </p>
        </section>

        <section>
          <h2>6. Your rights (ARCO / GDPR / CCPA)</h2>
          <p>
            If you are located in Mexico, you have the right to <strong>Access, Rectify, Cancel, or
            Object</strong> to the processing of your personal data ("ARCO rights") under the LFPDPPP. To
            exercise them, email <strong>xaltech1990@outlook.com</strong> with the subject "ARCO Rights",
            including your full name and specific request. We will respond within a maximum of 20 business
            days.
          </p>
          <p>
            If you reside in the <strong>European Economic Area, the United Kingdom, or Switzerland</strong>,
            you may exercise equivalent rights under the GDPR: access, rectification, erasure, restriction
            of processing, portability, and objection. If you reside in <strong>California, United
            States</strong>, you may exercise the rights provided by the CCPA/CPRA: the right to know,
            delete, and not be discriminated against for exercising these rights (Xaltech Fotos does not
            sell personal data to third parties for marketing purposes).
          </p>
          <p>
            For requests under the GDPR or CCPA, please also write to{' '}
            <strong>xaltech1990@outlook.com</strong> indicating the law under which you are exercising your
            right; we will handle your request within a reasonable time under the applicable legislation.
          </p>
        </section>

        <section>
          <h2>7. Photographs at public and private events</h2>
          <p>
            Photographs from <strong>public sporting events</strong> (races, triathlons, etc.) are taken
            where participants have previously registered with the event organizers. Photography in public
            spaces and events open to general participation is permitted under applicable law.
          </p>
          <p>
            For <strong>private events</strong> (weddings, graduations, baby showers, and similar), the
            photographer uploading the images to the platform represents that they have obtained
            authorization from the organizer and, where applicable, from the people photographed, to capture
            and commercialize those images through Xaltech Fotos.
          </p>
          <p>
            If the event takes place outside Mexico, the photographer is also responsible for complying
            with the local laws applicable to image rights and personal data in the country where the event
            takes place.
          </p>
          <p>
            If you need an image removed, contact us at <strong>xaltech1990@outlook.com</strong>.
          </p>
        </section>

        <section>
          <h2>8. Cookies and tracking technologies</h2>
          <p>
            Our website may use session cookies to maintain authentication state. We do not use third-party
            advertising tracking cookies.
          </p>
        </section>

        <section>
          <h2>9. Changes to this notice</h2>
          <p>
            We reserve the right to modify this notice at any time. Changes will be announced through our
            web platform at <strong>xaltechphotos.xaltech.online</strong>.
          </p>
        </section>

        <section>
          <h2>10. Contact</h2>
          <p>
            For any question or comment related to this privacy notice, contact us at:<br />
            📧 <strong>xaltech1990@outlook.com</strong><br />
            🌐 <strong>xaltechphotos.xaltech.online</strong>
          </p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
